import { defineMessages } from 'react-intl';

export default defineMessages({
    viewReplacementCostSummary: {
        id: 'ml.common.component.mlReplacementCostSummaryPrintButtonComponent.VIEW REPLACEMENT COST SUMMARY',
        defaultMessage: 'VIEW REPLACEMENT COST SUMMARY'
    },
    documentError: {
        id: 'ml.common.component.mlReplacementCostSummaryPrintButtonComponent.Error',
        defaultMessage: 'Error'
    },
    downloadDocError: {
        id: 'ml.common.component.mlReplacementCostSummaryPrintButtonComponent.We were unable to download your document, please try again.',
        defaultMessage: 'We were unable to download your document, please try again.'
    }
});
